export enum DeliveryGradesFormHeader {
  REGULAR = 'DATA ENTREGA REGULAR',
  RECOVERY = 'DATA ENTREGA RECUPERAÇÃO',
  ADITIONAL = 'DATA ENTREGA ADICIONAL',
}
